import type { UpdateProfileDto } from '../../volo/abp/account/models';

export interface CustomUpdateProfileDto extends UpdateProfileDto {
  newPassword?: string;
  currentPassword?: string;
  roles: string[];
  fileAttachmentId?: number;
  imageUrl?: string;
  pickUpId?: number;
  pickUpIds: number[];
  bio?: string;
  country?: string;
  region?: string;
  city?: string;
  address?: string;
  province?: string;
  specialities?: string;
  certification?: string;
  documentNumber?: string;
  paymentAccountDetails?: string;
}
